import {
    SET_CUSTOMER_NAME_REDUCER, SET_CUSTOMER_NAME_REQUEST, SET_CUSTOMER_NAME_SUCCESS, SET_CUSTOMER_NAME_FAILURE,
} from '../constants/customer_name.constants';

const initialState = {
    loading: false,
    valuations: [],
    customer_valuation: '',
    error: null,
};

export const Customer_name = (state = initialState, action) => {
    switch (action.type) {
    case SET_CUSTOMER_NAME_REDUCER:
        return {
            ...state,
            loading: false,
        };
    case SET_CUSTOMER_NAME_REQUEST:
        return {
            ...state,
            loading: true,
            _id: action._id,
            customer_name: action.customer_name,
        };
    case SET_CUSTOMER_NAME_SUCCESS:
        return {
            ...state,
            loading: false,
            _id: action._id,
            customer_name: action.customer_name,
        };
    case SET_CUSTOMER_NAME_FAILURE:
        return {
            ...state,
            _id: '',
            customer_name: '',
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/customer_name.reducers.js